class Labels {
	static testSystem = 'TEST SYSTEM';
}

export default Labels;
